export default __webpack_public_path__ + "97de57317555b09bc3666b3beb25cba0.wav";